import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import * as TaskManagementStateController from "../../store/StateControllers/TaskManagement/TaskManagementStateController";
import * as DataModels from "../../store/Models/TaskManagement/TaskManagementDataModel";
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import Layout from "../Layout";
import { ScrollableContent, TopActionButtons, TopActionsAndScrollableContentContainer } from "../core/TopActionsAndScrollableContentContainer";
import { TableColumn, TableRow, ToxnotReactTable } from "../core/ToxnotReactTable";
import './styles.css';
import React from "react";
import { SelectedInventoriesManager } from "../../store/Managers/SelectedInventoriesManager";
import { LoadingSpinner, LoadingSpinnerSize } from "../core/LoadingSpinner";
import TaskManagementDetailView from "./TaskManagementDetailView";
import { getDateIsoString, getLinkedItemLink } from "../../store/StateControllers/TaskManagement/TaskManagementStateController";
import Upsell, { UpsellTypes } from "../Upsell/Upsell";
import * as Helpers from "../../store/StateControllers/TaskManagement/Helpers";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";


interface DatesState {
    fromDate: string;
    toDate: string;
}

export type TaskProps = DataModels.TaskManagementState & ToxnotComponentProperties & typeof TaskManagementStateController.actionCreators & RouteComponentProps<{taskId: string}>;

class TaskManagementMain extends ToxnotSignInRequiredComponent<TaskProps, DatesState> {
    // ===============================================================================
    constructor(props: TaskProps) {
        super(props);
        this.state = {
            fromDate: '',
            toDate: '',
        };
    }

    protected override getDisallowedRoles() {
        return [];
    }

    private readonly _localStorageSaveTaskIdBeforeInventorySelectKey = "task-management-task-id-select-inventory";
    private readonly _localStorageSaveFilterbeforeInventorySelectKey = "task-management-filters-select-inventory";

    public async componentDidMount() { 
        await this.props.getTasks();
        const selectedInventoryIds = SelectedInventoriesManager.getThenClearSelectedInventorieFromLocalStorage(this.getUserContextForSignedInUser().userId);
        if (selectedInventoryIds !== null) {
            this.restoreStateAfterInventorySelectAndModifyTaskWithSelectedInventoryIds(selectedInventoryIds);
            this.props.getLinkedInventoriesNames(selectedInventoryIds);
        }
        if (this.props.match.params.taskId !== undefined) {
            this.props.setTaskManagementState({ openTaskId: this.props.match.params.taskId });
        }
    };

    //
    // Main Components
    //

    protected renderConcreteComponent(): JSX.Element | null {
        if (!this.getUserCapabilities().tasksEnabled) {
            return (
                <Upsell upsellType={UpsellTypes.Pro} conversionEvent="tasks" />
            );
        }

        if (!this.props.dataLoaded) {
            return (
                <Layout options={{ pinAppContentToWindowHeight: true }}>
                    <div className="tn-section">
                            <div className="text-center">
                                <LoadingSpinner size={LoadingSpinnerSize.Medium} />
                            </div>
                    </div>
                </Layout>
            );
        }

        return (
            <Layout options={{ pinAppContentToWindowHeight: true }} modalsRender={this.renderModals}>
                {/**Top Navbar*/}
                <div className="tn-section task-top-bar">
                    <button role="button" className="btn btn-toxnot-primary" onClick={this.addTask_ButtonClicked}><span className="glyphicon glyphicon-plus"></span>{this.localizeString(" Task")}</button>
                    <button role="button" className="btn btn-toxnot-danger" onClick={this.deleteTask_ButtonClicked}><span className="glyphicon glyphicon-remove"></span>{this.localizeString(" Tasks")}</button>
                </div>
                <TopActionsAndScrollableContentContainer shouldMakeTnSection={true} customClassName="task-content">
                    <TopActionButtons>
                        <div className="task-action-buttons-top-row">
                            <div className="btn-group">
                                <button className="btn btn-default dropdown-toggle" data-toggle="dropdown" type="button"><span className="glyphicon glyphicon-filter" aria-hidden="true"></span>{this.localizeString("Status ")}<span className="caret"></span></button>
                                <ul className="dropdown-menu">
                                    <li><a role="button" onClick={e => this.applyFilter(DataModels.TaskFilterType.Status, DataModels.TaskStatus.New)} >New</a></li>
                                    <li><a role="button" onClick={e => this.applyFilter(DataModels.TaskFilterType.Status, DataModels.TaskStatus.Active)}>Active</a></li>
                                    <li><a role="button" onClick={e => this.applyFilter(DataModels.TaskFilterType.Status, DataModels.TaskStatus.Closed)}>Closed</a></li>
                                </ul>
                            </div>
                            <div className="btn-group">
                                <button className="btn btn-default dropdown-toggle" data-toggle="dropdown" type="button"><span className="glyphicon glyphicon-filter" aria-hidden="true"></span>{this.localizeString("Assigned To ")}<span className="caret"></span></button>
                                <ul className="dropdown-menu scrollable-dropdown-menu">
                                    {   // order by first name, break ties with last name
                                        this.props.teamMembers
                                            .orderBy(teamMember => teamMember.lastName)
                                            .orderBy(teamMember => teamMember.firstName)
                                            .map((v, i) => {
                                            return (
                                                <li key={i}><a role="button" onClick={e => this.applyFilter(DataModels.TaskFilterType.UserId, v.userId)}>{Helpers.getAssignedTeamMemberName(v) + "."}</a></li>
                                            );
                                    })}
                                </ul>
                            </div>
                            <button className="btn btn-default" data-toggle="modal" data-target="#task-date-range-picker" type="button"><span className="glyphicon glyphicon-filter" aria-hidden="true"></span>{this.localizeString("Due Date")}</button>
                            <div className="input-group search-bar">
                                <input type="text" value={this.props.searchBarInput} onChange={e => this.props.setTaskManagementState({ searchBarInput: e.target.value })} onKeyDown={e => e.key === "Enter" ? this.applyFilter(DataModels.TaskFilterType.Search, this.props.searchBarInput) : null} className="form-control" placeholder={this.localizeString("Search For Tasks...")} />
                                <div className="input-group-btn">
                                    <button className="btn btn-default dropdown-toggle" type="button" onClick={e => this.applyFilter(DataModels.TaskFilterType.Search, this.props.searchBarInput)}><span className="glyphicon glyphicon-search"></span></button>
                                </div>
                            </div>
                        </div>
                        <div className="active-filters-container">
                            <div className="active-filter-values-container">
                                {Object.keys(this.props.taskFilters).map(filterType => this.props.taskFilters[(filterType as DataModels.TaskFilterType)].map(value =>
                                    <div key={filterType + value} className="active-filter-value">
                                        <span>{this.getFilterToFriendlyName(filterType as DataModels.TaskFilterType, value)}</span>
                                        {" "}
                                        <span className="remove-filter-value-button" onClick={e => this.removeFilter(filterType as DataModels.TaskFilterType, value)}>x</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </TopActionButtons>
                    <ScrollableContent>
                        <div className={(this.props.openTaskId !== null ? " drawer-backdrop" : "")}>
                            <ToxnotReactTable<DataModels.Task>
                                fullSectionWidth={false}
                                headerRow={this.getTaskTableHeaderRow()}
                                allRowModels={this.props.filteredAndSortedTaskIds.map(v => this.props.tasks[v])}
                                getRowForTable={this.getTaskTableRow}
                                localizer={this.props.appServices}
                                stickyHeader={true}
                                selectingRowOptions={{
                                    rowModelGetId: this.getTaskId,
                                    onRowSelected: this.taskTable_SelectionChanged,
                                    showOnlyOnHover: true
                                }}
                                enablePaging={false}
                                />
                        </div>
                    </ScrollableContent>
                    <TaskManagementDetailView localStorageTaskIdKey={this._localStorageSaveTaskIdBeforeInventorySelectKey} localStorageFilterKey={this._localStorageSaveFilterbeforeInventorySelectKey} />
                </TopActionsAndScrollableContentContainer>
            </Layout>  
        );
    }

    private handleFromDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newFromDate = event.target.value;
        this.setState({
            fromDate: newFromDate,
        });

        // Update the min value of the second date input and clear value if date is before min
        const toDateInput = document.getElementById('before-date-filter') as HTMLInputElement;
        if (toDateInput) {
            toDateInput.min = newFromDate;
            if (this.state.toDate < newFromDate) {
                this.setState({
                    toDate: "",
                });
            }
        }
    }

    private handleToDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newToDate = event.target.value;
        this.setState({
            toDate: newToDate,
        });
    }


    private renderModals = () => {

        return (
            <React.Fragment>
                <div id="task-date-range-picker" className="modal fade" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h4 className="modal-title">{this.localizeString("Filter Due Date")}</h4>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>{this.localizeString("Filter From")}</label>
                                    <input type="date" id="after-date-filter" className="form-control" value={this.state.fromDate} onChange={this.handleFromDateChange} placeholder={this.localizeString("Due After")} />
                                </div>
                                <div className="form-group">
                                    <label>{this.localizeString("Filter To")}</label>
                                    <input type="date" id="before-date-filter" className="form-control" value={this.state.toDate} onChange={this.handleToDateChange} placeholder={this.localizeString("Due Before")} />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-toxnot-primary" onClick={e => this.applyDateFilter()} data-dismiss="modal">{this.localizeString("Done")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
    
    private renderLinkedItems(task: DataModels.Task): JSX.Element | null {

        if (task.linkedItems.length === 0) {
            return null;
        } else if (task.linkedItems.length > 1) {
            return (
                <a role="button" onClick={e => this.taskRow_Clicked(task)}>{this.localizeString("View Linked Items")}</a>
            );
        } else if (task.linkedItems.length === 1 && task.linkedItems[0].itemType === DataModels.TaskManagementLinkedItemType.CustomerRequest) {
            return (
                <a role="button" href={getLinkedItemLink(task.linkedItems[0])} target="_blank">{this.localizeString("Open Linked Customer Request")}</a> //TODO
            );
        } else if (task.linkedItems.length === 1 && task.linkedItems[0].itemType === DataModels.TaskManagementLinkedItemType.Survey) {
            return (
                <a role="button" href={getLinkedItemLink(task.linkedItems[0])} target="_blank">{this.localizeString("Open Linked Survey")}</a>
            );
        } else if (task.linkedItems.length === 1 && task.linkedItems[0].itemType === DataModels.TaskManagementLinkedItemType.Inventory) {
            return (
                <a role="button" href={getLinkedItemLink(task.linkedItems[0])} target="_blank">{this.localizeString("Open Linked Material/Product")}</a>
            );
        } else {
            return (
                <a role="button" onClick={e => this.taskRow_Clicked(task)}>{this.localizeString("View Linked Items")}</a>
            );
        }          

    }

    //
    // Task Table Helpers
    //

    private getTaskTableHeaderRow = (): TableColumn<DataModels.Task>[] => {
        return [
            { value: this.renderTableSortableHeaders(DataModels.TaskSortableColumns.Title), isSortable: false, getSortableValue: ((model: DataModels.Task) => model.title) },
            { value: this.localizeString("Assigned To") },
            { value: this.renderTableSortableHeaders(DataModels.TaskSortableColumns.State), isSortable: false, getSortableValue: ((model: DataModels.Task) => model.status.toString()) },
            { value: this.renderTableSortableHeaders(DataModels.TaskSortableColumns.DueDate), isSortable: false, getSortableValue: ((model: DataModels.Task) => model.deadlineDate === null ? "" : new Date(model.deadlineDate).getTime().toString()) },
            { value: this.localizeString("Linked Items") }
        ]
    };

    private getTaskTableRow = (data: DataModels.Task, rowIndex: number): TableRow => {
        return {
            cols: [
                <div className="task-title" onClick={(e) => this.taskRow_Clicked(data)}>
                    <input autoComplete="off" className="form-control" type="text" id={"task-row-" + rowIndex.toString()} onKeyDown={e => e.key === "Enter" ? e.currentTarget.blur() : null} onClick={(e) => e.stopPropagation()} value={data.title} onChange={(e) => this.props.modifyTaskState(data.taskId, { title: e.target.value }, data)} />
                    <span className="task-title-text">{this.localizeString("View Details")}<span className="glyphicon glyphicon-chevron-right"></span></span>
                </div>,
                this.renderAssignedToSelect(data),
                this.renderStateSelect(data),
                this.renderDateInput(data),
                <div>{this.renderLinkedItems(data)}</div>
            ]
        }
    };

    private getTaskId(model: DataModels.Task): string {
        return model.taskId;
    };

    private taskTable_SelectionChanged = (selectedIds: { [id: string]: string }) => { 
        this.props.setTaskManagementState({
            selectedTaskIds: selectedIds
        })
    };

    private stringToTaskStatusEnumMap: { [str: string]: DataModels.TaskStatus } = {
        ["New"]: DataModels.TaskStatus.New,
        ["Active"]: DataModels.TaskStatus.Active,
        ["Closed"]: DataModels.TaskStatus.Closed
    }

    private addTask_ButtonClicked = (e: React.MouseEvent) => {
        this.props.addTask(this.props.appServices);
        this.props.filterTasks();
        document.getElementById("task-row-0")?.focus();
    }

    private deleteTask_ButtonClicked = (e: React.MouseEvent) => {
        this.props.deleteTasks(this.props.selectedTaskIds);
        this.props.filterTasks();
    }

    //
    //Linked Items Helpers
    //

    private restoreStateAfterInventorySelectAndModifyTaskWithSelectedInventoryIds(linkedInventoryIds: string[]) {

        const taskId = localStorage.getItem(this._localStorageSaveTaskIdBeforeInventorySelectKey);

        if (taskId === null) {
            return;
        }

        const linkedItems: DataModels.TaskManagementLinkedItem[] = linkedInventoryIds.map<DataModels.TaskManagementLinkedItem>(id => { return {itemId: id, itemType: DataModels.TaskManagementLinkedItemType.Inventory}});
        this.props.modifyTaskState(taskId, { linkedItems: linkedItems }, this.props.tasks[taskId]);
        localStorage.removeItem(this._localStorageSaveTaskIdBeforeInventorySelectKey);

        const filtersJson = localStorage.getItem(this._localStorageSaveFilterbeforeInventorySelectKey);
        if (filtersJson !== null) {
            try {
                const filters = JSON.parse(filtersJson) as { [filterType in DataModels.TaskFilterType]: string[] };
                this.props.setTaskManagementState({ taskFilters: filters });
                localStorage.removeItem(this._localStorageSaveFilterbeforeInventorySelectKey);
            }
            catch {
                console.log("Failed to restore filters.")
            }
        }

        if (this.props.dataLoaded) {
            this.taskRow_Clicked(this.props.tasks[taskId]);
        }
    }

    //===================================================================================

    private taskRow_Clicked = (rowModel: DataModels.Task) => {
        this.props.setTaskManagementState({ openTaskId: rowModel.taskId});
    };

    //
    //Filters
    //

    private applyDateFilter = () => {
        const dateAfter = (document.getElementById("after-date-filter") as HTMLInputElement).value;
        const dateBefore = (document.getElementById("before-date-filter") as HTMLInputElement).value;

        this.props.setTaskManagementState({
            taskFilters: {
                ...this.props.taskFilters,
                [DataModels.TaskFilterType.DeadlineDateBefore]: (dateBefore === "" ? [] : [dateBefore]),
                [DataModels.TaskFilterType.DeadlineDateAfter]: (dateAfter === "" ? [] : [dateAfter])
            }
        })

        this.props.filterTasks();

    }

    private applyFilter(filterType: DataModels.TaskFilterType, value: string) {
        let taskFilters = this.props.taskFilters;

        if (!taskFilters[filterType]) {
            taskFilters[filterType] = [];
        }
        
        if(taskFilters[filterType].includes(value)) {
            return;
        }

        if (filterType === DataModels.TaskFilterType.DeadlineDateAfter || filterType === DataModels.TaskFilterType.DeadlineDateBefore || filterType === DataModels.TaskFilterType.Search) {
            taskFilters[filterType] = [];
        }

        if (value === "") {
            this.props.setTaskManagementState({
                taskFilters: {
                    ...taskFilters,
                    [filterType]: []
                }
            });

            this.props.filterTasks();

            return;
        }

        this.props.setTaskManagementState({
            taskFilters: {
                ...taskFilters,
                [filterType]: [...taskFilters[filterType], value]
            }
        });

        this.props.filterTasks();
    }

    private removeFilter(filterType: DataModels.TaskFilterType, value: string) {
        if (!this.props.taskFilters[filterType]) {
            return;
        }

        this.props.setTaskManagementState({
            taskFilters: {
                ...this.props.taskFilters,
                [filterType]: this.props.taskFilters[filterType].filter(v => v !== value)
            }
        });

        this.props.filterTasks();
    }

    private getFilterToFriendlyName(filterType: DataModels.TaskFilterType, value: string) {
        switch (filterType) {
            case DataModels.TaskFilterType.Status:
                return this.localizeString("Status: ") + value;
            case DataModels.TaskFilterType.UserId:
                const user = this.props.teamMembers.find(v => v.userId === value);
                return this.localizeString("Assigned User: ") + Helpers.getAssignedTeamMemberName(user);
            case DataModels.TaskFilterType.Search:
                return value;
            case DataModels.TaskFilterType.DeadlineDateBefore:
                return this.localizeString("Before: ") + new Date(value).toDateString();
            case DataModels.TaskFilterType.DeadlineDateAfter:
                return this.localizeString("After: ") + new Date(value).toDateString();
            default:
                return "";
        }
    }

    //
    //Input Renderers
    //

    private renderAssignedToSelect(data: DataModels.Task): JSX.Element{
        return (
            <select className="form-control" value={data.assignedUserId ?? ""} onChange={(e) => this.updateAssignedTo(data.taskId, data, e.target.value)}>
                {this.props.teamMembers.map((v, i) => {
                    return (
                        <option value={v.userId} key={i}>
                            {Helpers.getAssignedTeamMemberName(v)}
                        </option>
                    );
                })}
            </select>  
        );
    }

    private renderStateSelect(data: DataModels.Task): JSX.Element {
        return (
            <select className="form-control task-status" value={data.status.toString()} data-value={data.status.toString()} onChange={(e) => this.updateStatus(data.taskId, data, e.target.value)}>
                <option value={DataModels.TaskStatus.New}>{this.localizeString("New")}</option>
                <option value={DataModels.TaskStatus.Active}>{this.localizeString("Active")}</option>
                <option value={DataModels.TaskStatus.Closed}> {this.localizeString("Closed")}</option>
            </select>    
        );
    }

    private renderDateInput(data: DataModels.Task): JSX.Element {
        return (
            <input type="date" className="form-control" value={data.deadlineDate?.substring(0, 10) ?? ""} onChange={(e) => this.updateDueDate(data.taskId, data, e.target.value)} />    
        );
    }

    private updateAssignedTo(taskId: string, selectedTask: DataModels.Task, newValue: string) {
        if (Object.keys(this.props.selectedTaskIds).length <= 1) {
            this.props.modifyTaskAssignedToState(taskId, newValue, selectedTask)
        } else {
            this.props.bulkUpdateTasksWithAssignedTo(this.props.selectedTaskIds, newValue);
        }
    }

    private updateStatus(taskId: string, selectedTask: DataModels.Task, newValue: string) {
        if (Object.keys(this.props.selectedTaskIds).length <= 1) {
            this.props.modifyTaskState(taskId, { status: this.stringToTaskStatusEnumMap[newValue] }, selectedTask)
        } else {
            this.props.bulkUpdateTasks(this.props.selectedTaskIds, { status: this.stringToTaskStatusEnumMap[newValue] });
        }
        this.props.filterTasks();
    }

    private updateDueDate(taskId: string, selectedTask: DataModels.Task, newValue: string) {
        if (Object.keys(this.props.selectedTaskIds).length <= 1) {
            this.props.modifyTaskDueDate(taskId, getDateIsoString(newValue), selectedTask)
        } else {
            this.props.bulkUpdateDueDateForTasks(this.props.selectedTaskIds, getDateIsoString(newValue));
        }
    }

    //Sorting
    //Supported sortColumns: 1,3,4

    private renderTableSortableHeaders(column: DataModels.TaskSortableColumns): JSX.Element {
        return (
            <div>
                <a role="button" onClick={e => this.props.sortTasks(column, !this.props.sortSettings.sortAscending)}>{this.sortableColumnToFriendlyText[column]}</a>
                {" "}
                {this.props.sortSettings.activeSortColumn === column && <span className={"glyphicon " + (this.props.sortSettings.sortAscending ? "glyphicon-chevron-up" : "glyphicon-chevron-down")}></span>}
            </div>
        );

    }

    private sortableColumnToFriendlyText: { [column in DataModels.TaskSortableColumns]: string } = {
        [DataModels.TaskSortableColumns.Title]: this.localizeString("Title"),
        [DataModels.TaskSortableColumns.State]: this.localizeString("State"),
        [DataModels.TaskSortableColumns.DueDate]: this.localizeString("Due Date"),
    }

}

export default connect(
    (state: ApplicationState) => ({ ...state.taskManagementState, appServices: state.appServices }),
    TaskManagementStateController.actionCreators
)(withRouter(TaskManagementMain) as any);